import CurrencyFormat from 'react-currency-format';
import { useOfferInlineEditStore } from './hooks/useOfferInlineEditStore';
import { getOfferInlineMetrics } from './offerInlineMetrics';
import type { IRowData } from './OfferTable';

interface OfferCpiCellProps {
  rowData: IRowData;
}

export const OfferCpiCell = ({ rowData }: OfferCpiCellProps) => {
  const localPrice = useOfferInlineEditStore(state => state.rows[rowData.product_uuid]?.localPrice ?? rowData.offer_final_price ?? null);
  const { offer_price_cpi } = getOfferInlineMetrics(rowData, localPrice);

  if (offer_price_cpi === null || offer_price_cpi === undefined) {
    return <div>--</div>;
  }

  return (
    <div>
      <CurrencyFormat fixedDecimalScale decimalScale={1} value={offer_price_cpi} displayType="text" suffix="%" decimalSeparator="," thousandSeparator="." />
    </div>
  );
};
